import {ChangeDetectionStrategy, Component, input, output} from "@angular/core";
import {MatIcon} from "@angular/material/icon";
import {CountdownTimerComponent} from "@common/components/countdown-timer/countdown-timer.component";
import {SimButton} from "@common/ui/button/sim-button.component";
import {TranslatePipe} from "@ngx-translate/core";
import {Translations} from "@translations";

@Component({
	selector: "sim-system-warning",
	templateUrl: "./sim-system-warning.component.html",
	styleUrls: ["./sim-system-warning.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [SimButton, MatIcon, CountdownTimerComponent, TranslatePipe],
})
export class SystemWarningComponent {
	// Constants
	protected readonly T = Translations;

	// I/O
	readonly nextSystemShutdown = input.required<number>();
	readonly timeUp = output();
	readonly cancelShutdown = output();
}
